import { render, staticRenderFns } from "./EditInstruction.vue?vue&type=template&id=f2cddeb8&scoped=true&"
import script from "./EditInstruction.vue?vue&type=script&lang=ts&"
export * from "./EditInstruction.vue?vue&type=script&lang=ts&"
import style0 from "./EditInstruction.vue?vue&type=style&index=0&id=f2cddeb8&scoped=true&lang=css&"
import style1 from "./EditInstruction.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2cddeb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VTextField,VTextarea})
